import { FunctionComponent, useEffect, useState } from "react";
import { isNil } from "lodash";

import { ColorPicker, ColorPickerHSBType, ColorPickerRGBType } from "primereact/colorpicker";
import { InputMask } from "primereact/inputmask";
import { Nullable } from "primereact/ts-helpers";

import "./SettingColorPicker.scss";

export interface ISettingColorPickerProps {
  value: string;
  onChange: (value: string) => void;
}

export const SettingColorPicker: FunctionComponent<ISettingColorPickerProps> = (props: ISettingColorPickerProps) => {
  const [color, setColor] = useState<string>(props.value);
  const [valid, setValid] = useState<boolean>(true);

  const onColorInputChange = (color: Nullable<string>) => {
    if (isNil(color)) {
      setValid(false);
      return;
    }

    const isValid = isValidColor(color);
    setValid(isValid);

    if (isValid && props.value !== color) {
      setColor(color);
      props.onChange(color);
    }
  };

  const onColorPickerChange = (color: Nullable<string | ColorPickerRGBType | ColorPickerHSBType>) => {
    const colorHex = `#${color?.toString()}`;
    if (!isNil(color) && isValidColor(colorHex) && props.value !== colorHex) {
      setColor(colorHex);
      props.onChange(colorHex);
    }
  };

  const isValidColor = (color: string) => {
    const colorHexValidatorRegExp = /^#([a-fA-F0-9]{3}|[a-fA-F0-9]{6})$/;
    return !!color && color.length === 7 && colorHexValidatorRegExp.test(color);
  };

  useEffect(() => {
    if (props.value !== color) {
      setColor(props.value);
      setValid(isValidColor(props.value));
    }
  }, [props.value]);

  return (
    <div className="color-picker">
      <ColorPicker format="hex" value={color} onChange={event => onColorPickerChange(event.value)} />

      <InputMask
        onChange={event => onColorInputChange(event.target.value)}
        value={color}
        mask="#******"
        className={`color-text-input ${valid ? "p-valid" : "p-invalid"}`}
      />
    </div>
  );
};
